
import React, { useEffect, useState } from 'react';

import './Quote.css';

import { faTwitter, faWhatsapp} from '@fortawesome/free-brands-svg-icons';

import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet';
import { copy } from "clipboard";



library.add(fab);

function Quote() {

  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");
  const [fontSize, setFontSize] = useState("1.6rem");

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");


  
  useEffect(() => {
    const path = window.location.pathname;
    const paramValue = path.split('/')[1] || 'random'; // extract parameter value from path
    const apiUrl = `https://www.pianomusicsoundtrack.com/quotes/crescita_personale/${paramValue}`; // construct API URL with parameter value

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setQuote(data.object.content);
        setAuthor("- " + data.object.author);
        if (data.object.content.length > 200  ) {
          setFontSize(1.2);
        }
        setTitle(data.object.title);
        setDescription(data.object.content);
      });
  }, []); 





  useEffect(() => {
    if (quote.length > 200) {
      setFontSize("1rem");
    }
  }, [quote]);


  useEffect(() => {
    const quoteContainer = document.querySelector('.quote-container');
    const authorContainer = document.querySelector('.author-container');
    const quoteHeight = quoteContainer.getBoundingClientRect().height;
    const authorHeight = authorContainer.getBoundingClientRect().height;
    authorContainer.style.marginTop = `${0}px`;
  }, [quote]);
  


  
  useEffect(() => {
    document.title = quote;
  }, []);

  function copyUrlToClipboard(url) {
    copy(url);
    const toast = document.getElementById("toast");
    toast.style.display = "flex";
    setTimeout(() => {
      toast.style.display = "none";
    }, 2000);
  }


  
  

  function shareOnTwitter() {
    const tweetText = `${title}\n\n - ${window.location.href}`;

    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      tweetText
    )}`;

    window.open(twitterUrl);
  }


  function handleContextMenu(event) {
    event.preventDefault();
  }







  function shareOnWhatsApp() {
    const message = `${title}\n\n - ${window.location.href}`;
    
  
    const whatsAppUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsAppUrl);
  }

  



  return (




    <div class="main" onContextMenu={handleContextMenu}>
      <>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
       
      </Helmet>
      </>
      
       
      <div id="toast">Link copiato!</div>
      <div class="quoter" onContextMenu={handleContextMenu}>
        <div class="quote-container">
      

          <p id="quote" className="quote" style={{ fontSize: fontSize }}>{quote}</p>  
         
        </div>
       
        
        <div class="author-container">
          <span id="author" class="author">- {author}</span>
        </div>
       
        <div class="controls-container">
          <div id="container-control-in" >
            <div class="btn">
              <div class="icon-container">
                <FontAwesomeIcon icon={faTwitter} onClick={shareOnTwitter} />
              </div>
            </div>
            <div class="btn">
              <div class="icon-container">
                <FontAwesomeIcon icon={faLink} onClick={() => copyUrlToClipboard(window.location.href)} />
              </div>
            </div>
            <div class="btn">
            <div class="icon-container">
              <FontAwesomeIcon icon={faWhatsapp} onClick={shareOnWhatsApp} />
            </div>
          </div>
          

    

          </div>
          
          
        </div>
        <div class="watermark">musica d'autore <br></br> pensata e creata solo per te  <br></br>  <a href="https://www.pianomusicsoundtrack.com">www.pianomusicsoundtrack.com</a></div>

     

      </div>
    </div>
  );
}

export default Quote;
